export default "__VITE_ASSET__C4m2jvXJ__"